import { useState, useCallback } from 'react';
import { message } from 'antd';
import { c322Api, ReportFilter, ReportData } from '../../../services/c322Api';

export interface C322ReportState {
  loading: boolean;
  reportData: ReportData | null;
  queried: boolean;
  noData: boolean;
}

export interface C322ReportActions {
  runQuery: (filter: ReportFilter) => Promise<void>;
  reset: () => void;
}

export function useC322Report(): C322ReportState & C322ReportActions {
  const [loading, setLoading] = useState(false);
  const [reportData, setReportData] = useState<ReportData | null>(null);
  const [queried, setQueried] = useState(false);
  const [noData, setNoData] = useState(false);

  const runQuery = useCallback(async (filter: ReportFilter) => {
    setLoading(true);
    setQueried(false);
    setNoData(false);
    try {
      const resp = await c322Api.query(filter);
      if (resp.data && resp.data.items.length > 0) {
        setReportData(resp.data);
        setNoData(false);
      } else {
        setReportData(null);
        setNoData(true);
        message.info(resp.message || '查無符合條件的訂單資料!');
      }
      setQueried(true);
    } catch {
      message.error('查詢失敗，請稍後再試');
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setReportData(null);
    setQueried(false);
    setNoData(false);
  }, []);

  return { loading, reportData, queried, noData, runQuery, reset };
}
